import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/splashPage/avatars/hao.webp'

export const HaoImage: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'Hao'} />
)
